/**
 * File: endpoints_urls.ts
 * Description: This file contains all the application URL endpoints
 */
import { API_URL } from '@/constants/constants'

export const ENDPOINT_PUBLIC_GET_ARTICLES = `${API_URL}/api/articles`

// Shared by admin article creation (POST, alone and with /:categoryId) and deletion (DELETE, with /:categoryId/:articleId appended).
export const ENDPOINT_ADMIN_ARTICLE = `${API_URL}/api/admin/article`

export const ENDPOINT_ADMIN_GET_ARTICLES = `${API_URL}/api/admin/articles`
